import React, { useEffect } from 'react'
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import ScrollableAnchor from "react-scrollable-anchor";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
  answerState,
  menuCheckSelector,
  selectedMenuItemState,
  surveyDataState,
  userState
} from '../../state/globalState'

/**
 * 설문 문항 컴포넌트
 */
const Survey6 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const userInfo = useRecoilValue(userState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const initialEmail = userInfo.emal || '';
    const [isError, setIsError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    let parentCompRef = props.compRef;

  useEffect(() => {
    // 최초 진입 시 userInfo.emal 값을 answer.email에 1회 주입 (이미 값이 있으면 유지)
    if ((answer.email === undefined || answer.email === '') && initialEmail) {
      setAnswer((prev) => ({ ...prev, email: initialEmail }));
      setSelectedMenuItem('SURVEY_13');
      setMenuCheck(true);
    }
  }, [initialEmail]);

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        // 이메일 검사 정규식
        const mailPattern = /^([0-9a-zA-Z_.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/i;
        let flag = false;

        if (value.length < 50) {
            setAnswer((prev) => ({
                ...prev,
                [column]: value,
            }));

            setSelectedMenuItem('SURVEY_13');
            setMenuCheck(value !== '');

            flag = mailPattern.test(value);

            if (value === '' || flag) {
                setIsError(false);
                setErrorMsg('');
                // dispatch(setError('0'));
            } else {
                setIsError(true);
                // dispatch(setError('13'));
                setErrorMsg('잘못된 이메일입니다.');
            }
        }
    };

    const addRefs = (e) => {
        parentCompRef[13] = e;
    };

    return (
        <>
            <ScrollableAnchor id={"13"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[13].title}
                        sentences={surveyData[13].questions}
                        step={13}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            label="여기에 이메일을 입력하십시오."
                            placeholder=""
                            margin="none"
                            error={isError}
                            helperText={errorMsg}
                            value={answer.email ?? initialEmail}
                            onChange={(e) => handleInputAnswer(e, 'email')}
                            inputRef={addRefs}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey6;
